import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { ContractTypeModel } from "../../models/ContractTypeModel";
import ContractTypeService from "../../services/ContractTypeService";
import ContractTypeSlice from "../slices/ContractTypeSlice";
import { RootState } from "../store";

export const ContractTypeActions = ContractTypeSlice.actions;
export const fetchContractTypes = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(ContractTypeActions.setIsContractTypesFetching(true));
    const response: ContractTypeModel[] =
      await ContractTypeService.getAllContractTypes();
    dispatch(ContractTypeActions.setContractTypes(response));
    dispatch(ContractTypeActions.setIsContractTypesFetching(false));
  };
};
export const fetchParticularContractType = (
  ContractType_id: number
): ThunkAction<void, RootState, unknown, AnyAction> => {
  return async (dispatch, getState) => {
    const response: ContractTypeModel =
      await ContractTypeService.getParticularContractType(ContractType_id);
    dispatch(ContractTypeActions.setParticularContractType(response));
  };
};
